import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { AccountEmailChange } from '../pages/account/account-email-change-dialog/account-email-change-dialog';
import { PasswordChange } from '../pages/account/password-change-dialog/password-change-dialog';
import { AccountEmailChangeConfirm } from '../pages/account/account-email-change-confirm-dialog/account-email-change-confirm-dialog';
import { ContactEmailChange } from '../pages/account/contact-email-change-dialog/contact-email-change-dialog';
import { ContactEmailChangeConfirm } from '../pages/account/contact-email-change-confirm-dialog/contact-email-change-confirm-dialog';
import { FormBuilderService, FormControlConfig } from '../decorator/form-control-config';
import { Validators } from '@angular/forms';
import { DisplayFormat } from '../decorator/display-format.decorator';
import { BillingEmailChangeConfirm } from '../pages/billing/payment-method/billing-email-change-confirm-dialog/billing-email-change-confirm-dialog';
import { BillingEmailChange } from '../pages/billing/payment-method/billing-email-change-dialog/billing-email-change-dialog';


export class GaeUser {

    // @FormControlConfig({})

    userId: string;

    @DisplayFormat({ translationKey: 'ITEM.ACCOUNT_EMAIL' })
    email: string;

    billingEmail: string;
    pendingBillingEmail?: string;
    pendingBillingEmailDate?: Date;

    // アカウントメールアドレス変更
    pendingAccountEmail?: string;
    pendingAccountEmailDate?: Date;

    contactEmail?: string;
    pendingContactEmail?: string;
    pendingContactEmailDate?: Date;

    customerName: string;

    invoiceRequestDate: Date;
    enableInvoice: boolean;
    invoiceLanguage: String;
    invoiceRequestPending: boolean;


    validContactEmail?: boolean;

    stripeCustomerId?: string;

    unsubscribe?: boolean;

    /**
     * 請求方法 (credit, invoice)
     */
    paymentType?: string;

    /**
     * 表示用の請求方法
     */
    paymentInfo?: string;

    /**
     * stripeの月額請求情報のID
     */
    stripeSubscriptionId?: string;

    /**
     * 現在のサブスクリプションの期間の終了日
     */
    stripeCurrentPeriodEnd?: Date;

    /**
     * プラン
     */
    plan?: string;

    enablePlans?: string[];

    /**
     * 現在のサブスクリプションで有効なプラン(nullのときは "plan"の設定値を利用する。)
     */
    currentSubscriptionPlan?: string;

    /**
     * 利用規約に同意した日付
     */
    agreedDate?: Date;


    dateRegistered?: Date;

}


export class InvoiceInfo {

    // @FormControlConfig({ validators: [Validators.required] })
    // customerName: string;

    @FormControlConfig({ validators: [Validators.required] })
    language: string;

}


export interface PaymentMethodInfo {
    // card, invoice
    type: string;
    id: string;
    useDefault: boolean;
    brand: string;
    last4: string;
    expMonth: number;
    expYear: number;
}

@Injectable({
    providedIn: 'root'
})
export class MyService {


    constructor(private http: HttpClient) { }

    getStripeClientSecret(): Observable<{ clientSecret: string }> {
        return this.http.get<{ clientSecret: string }>(environment.apiUrl + '/v1/my/stripe-client-secret');
    }
    getStripePublicKey(): Observable<{ key: string }> {
        return this.http.get<{ key: string }>(environment.apiUrl + '/v1/my/stripe-public-key');
    }

    getStripePaymentMethods(): Observable<PaymentMethodInfo[]> {
        return this.http.get<PaymentMethodInfo[]>(environment.apiUrl + '/v1/my/stripe-payment-methods');
    }

    setDefaultPaymentMethod(paymentMethodId: string): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/stripe-payment-methods/" + paymentMethodId + "/default", {});
    }

    setDefaultInvoicePaymentMethod(): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/stripe-payment-methods/invoice/default", {});
    }

    deletePaymentMethod(paymentMethodId: string): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/stripe-payment-methods/" + paymentMethodId + "/detach", {});
    }

    getStripeSetupIntent(): Observable<any> {
        return this.http.get<any>(environment.apiUrl + '/v1/my/stripe-setup-intent');
    }

    requestInvoice(): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/request-invoice", {});
    }


    updateInvoiceSettings(requestInvoice: InvoiceInfo): Observable<any> {
        return this.http.put(environment.apiUrl + "/v1/my/invoice-settings", requestInvoice);
    }

    updateBillingInfo(billingInfo: any): Observable<any> {
        return this.http.put(environment.apiUrl + "/v1/my/billing-info", billingInfo);
    }

    getBillingInfo(): Observable<any> {
        return this.http.get(environment.apiUrl + "/v1/my/billing-info");
    }

    getMyUser(): Observable<GaeUser> {
        return this.http.get<GaeUser>(environment.apiUrl + '/v1/my');
    }

    changePassword(request: PasswordChange): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-password", request);
    }

    changeAccountEmail(request: AccountEmailChange): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-account-email", request);
    }

    cancelChangeAccountEmail(): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-account-email/cancel", {});
    }

    changeAccountEmailConfirm(request: AccountEmailChangeConfirm): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-account-email/confirm", request);
    }


    changeContactEmail(request: ContactEmailChange): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-contact-email", request);
    }

    cancelChangeContactEmail(): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-contact-email/cancel", {});
    }

    changeContactEmailConfirm(request: ContactEmailChangeConfirm): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-contact-email/confirm", request);
    }

    requestInvoicePaymentMethod(): Observable<any> {
        throw new Error('Method not implemented.');
    }


    changeBillingEmail(request: BillingEmailChange): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-billing-email", request);
    }

    cancelChangeBillingEmail(): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-billing-email/cancel", {});
    }

    changeBillingEmailConfirm(request: BillingEmailChangeConfirm): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/change-billing-email/confirm", request);
    }



    getPlans(): Observable<any[]> {
        return this.http.get<any[]>(environment.apiUrl + '/v1/my/plans');
    }

    selectPlan(priceId: string): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/plans/" + priceId, {});
    }

    cancelNextPlan(): Observable<any> {
        return this.http.delete(environment.apiUrl + "/v1/my/plans/next", {});
    }


    previewPlan(priceId: string): Observable<any> {
        return this.http.post(environment.apiUrl + "/v1/my/plans/" + priceId + "/preview", {});
    }

    getSubscriptedPlan(): Observable<any[]> {
        return this.http.get<any[]>(environment.apiUrl + '/v1/my/subscripted-plan');
    }



    getStripeBillingCustomerPotalUrl(): Observable<any> {
        return this.http.get<any>(environment.apiUrl + '/v1/my/stripe-billing-portal-sessions');
    }
    


}